import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { prettyPrintWasteProgram } from "encamp-shared/src/waste/wasteProgramLabel";
import { WasteKind } from "generated-graphql/graphql";

export const prettyPrintWasteClassification = (
  classification: string | null | undefined
): string => {
  if (!classification) return "";
  return prettyPrintEnumValue(classification)?.replace("Rcra", "RCRA") ?? "";
};

export { prettyPrintWasteProgram };

/**
 * A stream's hazard class and management program as one label, program first:
 * "Universal Waste · RCRA Hazardous".
 *
 * The two are separate fields because state programs pull them apart — a
 * federal universal waste category in a state that hasn't adopted it is
 * regulated hazardous waste there — but a reader wants one label, so they are
 * joined here and nowhere upstream.
 *
 * `WasteKind.Rcra` and a null kind both mean no special program applies, and
 * both return the classification by itself. That covers ordinary streams and
 * tenants whose feature flag withholds the kind, so those labels are
 * byte-identical to what they were before the kind existed.
 */
export const prettyPrintWasteStreamLabel = (
  classification: string | null | undefined,
  wasteKind: WasteKind | null | undefined
): string => {
  const hazard = prettyPrintWasteClassification(classification);
  const program = prettyPrintWasteProgram(wasteKind);
  if (!program) return hazard;

  return hazard ? `${program} · ${hazard}` : program;
};
